import React from 'react';
import { Cookie } from 'lucide-react';

const Cookies = () => {
  return (
    <div className="min-h-screen bg-dark-base py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <Cookie className="h-12 w-12 text-primary mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-white">Política de Cookies</h1>
          <p className="mt-2 text-gray-400">Última actualización: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="prose prose-invert max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">1. ¿Qué son las Cookies?</h2>
            <p className="text-gray-300">
              Las cookies son pequeños archivos de texto que los sitios web colocan en tu dispositivo para almacenar información sobre tus preferencias o actividad.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">2. Tipos de Cookies que Utilizamos</h2>
            
            <h3 className="text-xl font-semibold text-white mt-6 mb-3">2.1 Cookies Necesarias</h3>
            <p className="text-gray-300">
              Son esenciales para el funcionamiento del sitio web:
            </p>
            <ul className="list-disc list-inside text-gray-300 mt-2">
              <li>Mantener tu sesión activa</li>
              <li>Recordar tus preferencias básicas</li>
              <li>Garantizar la seguridad del sitio</li>
            </ul>

            <h3 className="text-xl font-semibold text-white mt-6 mb-3">2.2 Cookies Analíticas</h3>
            <p className="text-gray-300">
              Nos ayudan a entender cómo utilizas el sitio:
            </p>
            <ul className="list-disc list-inside text-gray-300 mt-2">
              <li>Páginas visitadas</li>
              <li>Tiempo de permanencia</li>
              <li>Errores encontrados</li>
            </ul>

            <h3 className="text-xl font-semibold text-white mt-6 mb-3">2.3 Cookies de Marketing</h3>
            <p className="text-gray-300">
              Utilizadas para personalizar la publicidad:
            </p>
            <ul className="list-disc list-inside text-gray-300 mt-2">
              <li>Mostrar anuncios relevantes</li>
              <li>Medir la efectividad de campañas</li>
              <li>Evitar mostrar anuncios repetitivos</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">3. Control de Cookies</h2>
            <p className="text-gray-300">
              Puedes controlar las cookies de varias formas:
            </p>
            <ul className="list-disc list-inside text-gray-300 mt-2">
              <li>Configuración del navegador</li>
              <li>Panel de preferencias de cookies del sitio</li>
              <li>Herramientas de terceros</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">4. Cookies de Terceros</h2>
            <p className="text-gray-300">
              Algunos servicios de terceros que utilizamos pueden establecer sus propias cookies:
            </p>
            <ul className="list-disc list-inside text-gray-300 mt-2">
              <li>Google Analytics</li>
              <li>Redes sociales</li>
              <li>Servicios de pago</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">5. Contacto</h2>
            <p className="text-gray-300">
              Para cualquier consulta sobre nuestra política de cookies, contáctanos en:{' '}
              <a href="mailto:info@asistentetradingia.com" className="text-primary hover:text-primary-hover">
                info@asistentetradingia.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Cookies;